import { createUseStyles } from 'react-jss'

import { COLOR, MQ } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    background: COLOR.ORANGE,
    padding: [84, 0, 108, 0],
    [MQ.TABLET]: {
      flexDirection: 'row',
      padding: [132, 32, 126, 32],
    },
  },
  container: {
    maxWidth: 1054,
    margin: [0, 'auto'],
    display: 'flex',
    flexDirection: 'column',
    [MQ.TABLET]: {
      flexDirection: 'row',
    },
  },
  contentWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    [MQ.TABLET]: {
      width: '50%',
      justifyContent: 'center',
    },
  },
  content01: {
    [MQ.TABLET]: {
      alignItems: 'flex-start',
    },
  },
  logoWrapper: {
    width: 249,
    height: 73,
    marginBottom: 77,
    [MQ.TABLET]: {
      width: 298,
      height: 88,
      marginBottom: 0,
    },
    [MQ.TABLET_LARGE]: {
      width: 390,
      height: 112,
    },
  },
  content02: {
    [MQ.TABLET]: {
      alignItems: 'flex-end',
    },
  },
  textWrapper: {
    color: COLOR.OFF_WHITE,
    marginBottom: 12,
    width: 155,
    padding: [0, 5],
    textAlign: 'center',
    [MQ.TABLET]: {
      textAlign: 'left',
    },
  },
  linksContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: 155,
    justifyContent: 'space-between',
  },
  link: {
    height: 37,
    width: 37,
    display: 'flex',
    boxSizing: 'border-box',
  },
  linkInstagram: {
    padding: 5,
  },
  linkEmail: {
    padding: 4,
  },
  darkGreen: {
    background: COLOR.DARK_GREEN,
  },
  lightGreen: {
    background: COLOR.LIGHT_GREEN,
  },
  mustard: {
    background: COLOR.YELLOW,
  },
  social: {
    '& path': {
      fill: COLOR.OFF_WHITE,
    },
  },
  logo: {
    '& path': {
      fill: COLOR.OFF_WHITE,
    },
    '& rect': {
      fill: COLOR.OFF_WHITE,
    },
  },
  hidden: {
    position: 'absolute',
    left: '-200vw',
  },
})
